<template>
  <div id="app">
    <router-view></router-view>
    <init-system-modal ref="initSystemModal"></init-system-modal>
    <open-update-sys ref="OpenUpdateSys"></open-update-sys>
  </div>
</template>

<script>
import {ipcRenderer} from "electron";
import InitSystemModal from "@/views/layout/components/init-system-modal.vue";
import OpenUpdateSys from "@/views/layout/components/open-update-sys.vue";

const isDevelopment = process.env.NODE_ENV !== "production";

export default {
  name: 'App',
  components: {
    InitSystemModal,
    OpenUpdateSys
  },
  methods: {
    appUpdate(event, args, res, type) {
      // console.log(res, type);
      if ([1, 2, 3].includes(type)) {//有版本更新
        this.$refs.OpenUpdateSys.open(res, type);
      }
    }
  },
  mounted() {
    ipcRenderer.send('checkForUpdate');
    ipcRenderer.on('app.update', this.appUpdate);
    this.$once('hook:beforeDestroy', () => {
      ipcRenderer.removeListener('app.update', this.appUpdate)
    })

    ipcRenderer.on('init.system.message', (event, args) => {
      if (args.status !== 3) {
        this.$refs.initSystemModal.open(args);
      }
    });
    setTimeout(() => {
      Promise.all([
        ipcRenderer.invoke('init.system.chrome'),
        ipcRenderer.invoke('init.system.ffmpeg'),
        ipcRenderer.invoke('init.system.ffmpeg-3'),
        ipcRenderer.invoke('init.system.font'),
      ]).then(async () => {
        if (isDevelopment) {
          return;
        }

        const count = await ipcRenderer.invoke('video.record.retry.all.check');
        if (!count) {
          return;
        }

        this.$Modal.confirm({
          title: '温馨提示',
          content: `发现共计(${count})个发布任务待执行，是否现在立即启动？`,
          onOk: () => {
            ipcRenderer.invoke('video.record.retry.all');
          }
        });
      });
    }, 3000)
    // this.$router.push('/videoPublish')
  }
};
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsisMany {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
